import { useContext } from "react";
import { iFeatureFlagContext, FeatureFlagContext } from "./featureflagprovider";

interface iUseFeatureFlag {
  getFlagValue: any;
  addProperty: any;
  loading: any;
}

export const useFeatureFlag = (): iUseFeatureFlag => {
  const { getFlagValue, addProperty, loading } = useContext<iFeatureFlagContext>(FeatureFlagContext);
  return { getFlagValue, addProperty, loading };
};

export default useFeatureFlag;
